/*
 *  Global Components, Services entry point
 */

import * as components from "./components.js";
import * as dsComponents from "@/design-system/components.js";
import services from "./components/services.js";
import tooltipDirective from "@/components/tooltip.directive.js";
import facade from "@/plugins/input-facade/directive.js";
import focusTrap from "./plugins/focus-trap.js";

const plugin = {
  install(Vue, options) {
    for (const item in components) {
      const component = components[item];
      Vue.component(component.name, component);
    }

    for (const item in dsComponents) {
      const component = dsComponents[item];
      Vue.component(component.name, component);
    }

    for (const key in services) {
      const value = services[key];
      // console.log(`Services: ${key}, Value: ${value}`);
      Vue.provide(key, value);
    }

    Vue.directive("tooltip", tooltipDirective);
    Vue.directive("facade", facade);
    Vue.directive("focusTrap", focusTrap);

    // Toastr setup
    const toastr = window.toastr;
    if (toastr) {
      if (options) {
        toastr.options = options;
      }
      toastr.options = toastr.options || {};
      toastr.options.escapeHtml = true; // XSS fix

      Vue.config.globalProperties.$toastr = {};
      Vue.config.globalProperties.$toastr.warning = (
        message = "",
        title = "",
        optionsOverride = {}
      ) => {
        return toastr.warning(message, title, optionsOverride);
      };
      Vue.config.globalProperties.$toastr.success = (
        message = "",
        title = "",
        optionsOverride = {}
      ) => {
        return toastr.success(message, title, optionsOverride);
      };
      Vue.config.globalProperties.$toastr.error = (
        message = "",
        title = "",
        optionsOverride = {}
      ) => {
        return toastr.error(message, title, optionsOverride);
      };
      Vue.config.globalProperties.$toastr.info = (
        message = "",
        title = "",
        optionsOverride = {}
      ) => {
        return toastr.info(message, title, optionsOverride);
      };
      Vue.config.globalProperties.$toastr.remove = () => {
        toastr.remove();
      };
      Vue.config.globalProperties.$toastr.clear = () => {
        toastr.clear();
      };
    } else {
      // No-op implementation when toastr not available (Magellan disabled)
      Vue.config.globalProperties.$toastr = {
        warning: () => null,
        success: () => null,
        error: () => null,
        info: () => null,
        remove: () => {},
        clear: () => {}
      };
    }
  }
};

export default plugin;
